import { IS_UAE_HOST } from 'flow/utils/browser-utils-TW';
import appConfig from 'app-config';

export const uaePassLoginStatus = {
    IDLE: 'idle',
    WAITING: 'waiting',
    SUCCESS: 'success',
    ERROR: 'error',
} as const;

// Must stay in sync with `VALID_UAE_PASS_ERRORS` in
// electron/app/channels/uae-pass/uae-pass-listeners.js.
// The two builds can't share a module, so additions must be mirrored there.
export const uaePassErrors = {
    SERVICE_NOT_FOUND: 'service_not_found',
    MISSING_CODE: 'missing_code',
    MISSING_STATE: 'missing_state',
    USER_CANCELLED: 'user_cancelled',
    NOT_ELIGIBLE: 'not_eligible',
    NOT_AUTHENTICATED: 'not_authenticated',
    TIMEOUT: 'timeout',
    GENERIC: 'generic',
} as const;

export const uaeWindowCloseReasons = {
    REDIRECT: 'redirect',
    USER_CLOSED: 'user_closed',
} as const;

export const uaePassSignInResult = {
    OK: 'ok',
    ERROR: 'error',
} as const;

export const isUaePassEnabled =
    (IS_UAE_HOST || appConfig.dev) && appConfig.isUaePassEnabled;
